module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<app-header [sections]=\"sections\"></app-header>\n<router-outlet></router-outlet>\n<footer></footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main